var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 96,
    viewBox: "0 0 109 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2343_1576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 6.5V72.125C17 73.8828 18.3672 75.25 20.125 75.25H98.25C101.57 75.25 104.5 78.1797 104.5 81.5C104.5 85.0156 101.57 87.75 98.25 87.75H20.125C11.3359 87.75 4.5 80.9141 4.5 72.125V6.5C4.5 3.17969 7.23438 0.25 10.75 0.25C14.0703 0.25 17 3.17969 17 6.5ZM42 31.5C38.4844 31.5 35.75 28.7656 35.75 25.25C35.75 21.9297 38.4844 19 42 19C45.3203 19 48.25 21.9297 48.25 25.25C48.25 28.7656 45.3203 31.5 42 31.5ZM67 44C67 47.5156 64.0703 50.25 60.75 50.25C57.2344 50.25 54.5 47.5156 54.5 44C54.5 40.6797 57.2344 37.75 60.75 37.75C64.0703 37.75 67 40.6797 67 44ZM79.5 62.75C75.9844 62.75 73.25 60.0156 73.25 56.5C73.25 53.1797 75.9844 50.25 79.5 50.25C82.8203 50.25 85.75 53.1797 85.75 56.5C85.75 60.0156 82.8203 62.75 79.5 62.75ZM92 19C92 22.5156 89.0703 25.25 85.75 25.25C82.2344 25.25 79.5 22.5156 79.5 19C79.5 15.6797 82.2344 12.75 85.75 12.75C89.0703 12.75 92 15.6797 92 19ZM35.75 62.75C32.2344 62.75 29.5 60.0156 29.5 56.5C29.5 53.1797 32.2344 50.25 35.75 50.25C39.0703 50.25 42 53.1797 42 56.5C42 60.0156 39.0703 62.75 35.75 62.75Z",
    fill: "#12007B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2343_1576",
    x: 0.5,
    y: 0.25,
    width: 108,
    height: 95.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2343_1576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2343_1576",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestBold);
export default __webpack_public_path__ + "static/media/test_bold.dd5f6a50f4e303dd166b0596c3c5fd17.svg";
export { ForwardRef as ReactComponent };